import { useCallback, useState } from "react";
import { useBoolean } from "@/ui-kit";
import type { IServiceArea } from "@/types/common";
import { ContractorsRepository } from "@/api/contractors/repository";
import { ContractorsService } from "@/api/contractors/service";
import { ServiceAreasCard } from "@/components/profile-cards";
import { ServiceAreasEditModal } from "@/components/profile-forms/ServiceAreasForm";

type IProps = {
  userId: number;
  serviceAreas: IServiceArea[];
};

export const ServiceAreas = ({ userId, serviceAreas }: IProps) => {
  const [values, setValues] = useState<IServiceArea[]>(serviceAreas);

  const {
    value: showEditModal,
    setTrue: openEditModal,
    setFalse: dismissEditModal,
  } = useBoolean(false);

  const updateValues = useCallback((v: IServiceArea[]) => {
    setValues(v);
  }, []);

  const updateServiceArea = useCallback(
    (params: { userId: number; serviceAreas: IServiceArea[] }) => {
      const contractorsRepository = new ContractorsRepository(
        new ContractorsService(),
      );
      return contractorsRepository.updateContractorServiceArea(params);
    },
    [],
  );

  return (
    <>
      <ServiceAreasCard serviceAreas={values} onEdit={openEditModal} />
      {showEditModal && (
        <ServiceAreasEditModal
          userId={userId}
          serviceAreas={values}
          updateServiceArea={updateServiceArea}
          onSave={updateValues}
          onDismiss={dismissEditModal}
        />
      )}
    </>
  );
};
